import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { getPalette } from 'owa-theme';

export interface LocationWellColor {
    rootColor: string;
    rootSecondaryColor: string;
    selectedColor: string;
    selectedHoverColor: string;
    textColor: string;
    pillBackground: string;
    closeButtonHover: string;
    closeButtonSelectedHover: string;
}

export const generateLocationWellColor = (colorScheme: ColorScheme): LocationWellColor => {
    const themeSymbols = getPalette();
    return {
        rootColor: colorScheme ? colorScheme.calPrimary : themeSymbols.themePrimary,
        rootSecondaryColor: colorScheme ? colorScheme.calSecondary : themeSymbols.themeSecondary,
        selectedColor: colorScheme ? colorScheme.calLighter : themeSymbols.themeLighter,
        selectedHoverColor: colorScheme ? colorScheme.calLight : themeSymbols.themeLight,
        textColor: colorScheme ? colorScheme.calDark : themeSymbols.themeDark,
        pillBackground: colorScheme ? colorScheme.calLighterAlt : themeSymbols.themeLighterAlt,
        closeButtonHover: colorScheme ? colorScheme.calLight : themeSymbols.themeLight,
        closeButtonSelectedHover: colorScheme ? colorScheme.calDark : themeSymbols.themeDark,
    };
};
